













 
























































const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "event"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "options"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event",
        "variableName": "event"
      },
      {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
      }
    ],
    "kind": "ScalarField",
    "name": "segmentEventTrack",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendClientSegmentEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendClientSegmentEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "m_F8GHMJhbYTeI2F8J0BHHWw",
    "metadata": {},
    "name": "SendClientSegmentEventMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "f3c8278b870a1a29fe44456508b258c0";

export default node;
